import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20flowing%20organic%20shapes%20in%20terracotta%20and%20cream%20tones%2C%20minimalist%20artistic%20composition%2C%20subtle%20texture%2C%20modern%20elegant%20aesthetic%2C%20no%20text%2C%20no%20people%2C%20soft%20diffused%20lighting%2C%20high%20end%20background%20for%20creative%20agency%20website&width=1800&height=900&seq=hero-bg-tangxin&orientation=landscape"
          alt="糖心传媒品牌内容营销"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-background-50/15 backdrop-blur-sm border border-background-50/20 rounded-full px-4 py-2 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            <span className="text-background-50/90 text-sm font-medium">品牌内容营销首选</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
            让品牌内容<span className="text-accent-400">被看见</span>
            <br />
            让商业增长<span className="text-accent-400">可度量</span>
          </h1>

          <p className="text-background-50/75 text-base md:text-lg leading-relaxed mb-8 max-w-xl">
            糖心传媒专注品牌内容创作与数字营销，提供短视频制作、社交媒体运营、KOL合作及全案策划服务，助力品牌突破流量瓶颈，实现精准曝光与用户转化增长。
          </p>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <Link
              to="/about"
              className="bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3.5 rounded-full text-sm font-semibold transition-all hover:scale-105 whitespace-nowrap"
            >
              立即咨询合作
            </Link>
            <Link
              to="/category/all"
              className="flex items-center gap-2 text-background-50/80 hover:text-background-50 text-sm font-medium transition-colors whitespace-nowrap"
            >
              <span>浏览案例洞察</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 hidden md:block">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-background-50/50 text-2xl"></i>
        </div>
      </div>
    </section>
  );
}